export const AttendanceConst = {
  NONE: 0,
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3,
};

export const PageSize = 2;

/**
 * Parent Capability constant
 * @CapabilityID    Attendance: 5
 * @CapabilityID    Cause of presence and absence: 6
 * @CapabilityID    ClassSchedule: 14
 * @CapabilityID    Content: 68
 * @CapabilityID    Homework: 7
 * @CapabilityID    Exams: 8
 * @CapabilityID    News: 9
 * @CapabilityID    Gallery: 13
 * @CapabilityID    About School (Home School): 15
 * @CapabilityID    Edit Student: 17
 *
 * /////////////////////////////////////////////////////////
 *
 * Teacher Capability constant
 * @CapabilityID    Submit attendance: 40
 * @CapabilityID    See attendance: 90
 * @CapabilityID    See examination schedule: 45
 * @CapabilityID    Submit exam: 47
 * @CapabilityID    See homework: 49
 * @CapabilityID    Submit homework: 50
 * @CapabilityID    See profile: 51
 * @CapabilityID    Content: 67
 * @CapabilityID    Report: 75
 * @CapabilityID    See Gallery: 80
 * @CapabilityID    Submit Gallery: 81
 * @CapabilityID    See News: 85
 * @CapabilityID    Submit News: 86
 * @CapabilityID    See Notes: 94
 * @CapabilityID    Submit Notes: 95
 * @CapabilityID    Submit category: 98
 */
export const CapabilityConst =
  process.env.NEXT_PUBLIC_APP_TYPE === "teacher"
    ? [40, 90, 45, 47, 49, 50, 51, 67, 75, 80, 81, 85, 86, 94, 95, 98]
    : [5, 6, 7, 8, 9, 13, 14, 15, 17, 68];

export const CapabilityConstId =
  process.env.NEXT_PUBLIC_APP_TYPE === "teacher"
    ? {
      attendance: 90,
      // causePA: 6,
      // classSchedule: 14,
      content: 67,
      homework: 49,
      exams: 45,
      news: 85,
      gallery: 80,
      report: 75,
      notes: 94,
      profile: 51,
      // homeSchool: 15,
      // editStudent: 15,
    }
    : {
      attendance: 5,
      causePA: 6,
      classSchedule: 14,
      content: 68,
      homework: 7,
      exams: 8,
      news: 9,
      gallery: 13,
      homeSchool: 15,
      editStudent: 15,
    };

export const PAGE_SIZE = 10;